import './../../external/@lit/reactive-element/reactive-element.js';
import { html as y } from './../../external/lit-html/lit-html.js';
import { LitElement as s } from './../../external/lit-element/lit-element.js';
import HorizontalNavigationCss from "./HorizontalNavigationCss.js";
import "../Link/Link.js";
class HorizontalNavigation extends s {
  static get styles() {
    return [HorizontalNavigationCss];
  }
  static get properties() {
    return {
      items: { type: Array }
    };
  }
  constructor() {
    super();
    this.items = [];
  }
  render() {
    return y`
      <style>
        @import '${iscecoWidgetLibrary.iconCss}'
      </style>
      <nav>
        <div class="desktop">
          ${this.items.map((item) => this._renderLink(item))}
        </div>
        <div class="mobile">
          <button class="hamburger-menu"
                  title=" "
                  @click="${() => this._triggerMobileMenu()}">
            <i class="bars icon"></i>
          </button>
          <div>
            ${this.items.map((item) => this._renderLink(item))}
          </div>
        </div>
      </nav>
    `;
  }
  _renderLink(item) {
    const icon = item.icon ? y`<i class="icon ${item.icon}"></i>` : "";
    return y`
      <isceco-link url="${item.url}" @click="${(_) => this._hideMobileMenu()}">
        <div class="navigation-item ${this._getActive(item)}">
          ${icon}
          ${item.text}
        </div>
      </isceco-link>
    `;
  }
  _triggerMobileMenu() {
    const mobileUl = this.shadowRoot.querySelector(".mobile > div");
    const hamburgerMenu = this.shadowRoot.querySelector(".hamburger-menu > i");
    mobileUl.classList.toggle("show");
    if (mobileUl.classList.contains("show")) {
      hamburgerMenu.className = "close icon";
    } else {
      hamburgerMenu.className = "bars icon";
    }
  }
  _hideMobileMenu() {
    const mobileDisplay = this.shadowRoot.querySelector(".mobile");
    if (getComputedStyle(mobileDisplay).display !== "none") {
      this._triggerMobileMenu();
    }
  }
  _getActive(item) {
    if (getNavigationHash() === "" && item.active) {
      return "active";
    }
    if (item.suburls !== void 0 && item.suburls.length !== null && item.suburls.indexOf(getNavigationHash()) >= 0) {
      return "active";
    }
    return item.url === getNavigationHash() ? "active" : "";
  }
}
customElements.define("isceco-horizontal-navigation", HorizontalNavigation);
export { HorizontalNavigation };
